export { addInputText } from './common';



/** WEBPACK FOOTER **
 ** ../src/dash/front/inputs/index.js
 **/